import {
  f as _Char___init__impl__6a9atx,
  i as Char__plus_impl_qi7pgj,
  m6 as objectMeta,
  ga as VOID,
  o6 as setMetadataFor,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class Hex {
  constructor() {
    Hex_instance = this;
  }
  g35(v) {
    return v >= 10 ? Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(97), v - 10 | 0) : Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(48), v);
  }
}
//endregion
var Hex_instance;
function Hex_getInstance() {
  if (Hex_instance === VOID)
    new Hex();
  return Hex_instance;
}
//region block: post-declaration
setMetadataFor(Hex, 'Hex', objectMeta);
//endregion
//region block: exports
export {
  Hex_getInstance as a,
};
//endregion

//# sourceMappingURL=korge-root-krypto.mjs.map
